var map = {
	"./account.svg": 706,
	"./arrow-double.svg": 671,
	"./building.svg": 707,
	"./cart-outline.svg": 708,
	"./cart.svg": 709,
	"./checkmark-circle.svg": 710,
	"./chevron.svg": 711,
	"./credit.svg": 712,
	"./digital-print.svg": 713,
	"./email.svg": 714,
	"./facebook.svg": 715,
	"./flash-danger.svg": 716,
	"./home-inverse.svg": 717,
	"./home.svg": 718,
	"./hour-glass.svg": 719,
	"./large-area-print.svg": 720,
	"./logout.svg": 721,
	"./menu-hamburger.svg": 722,
	"./phone.svg": 723,
	"./photoproducts.svg": 724,
	"./print-demand.svg": 725,
	"./remove-image.svg": 726,
	"./settings.svg": 727,
	"./skype.svg": 728,
	"./star.svg": 729,
	"./truck.svg": 730,
	"./twitter.svg": 731,
	"./user.svg": 732,
	"./youtube.svg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;